import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

function Banner() {
  return (
    <section className="wrapper banner-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              autoplay={{ delay: 3000, pauseOnMouseEnter: true }}
              loop
            >
              <SwiperSlide>
                <div className="item">
                  <div className="slide-text">
                    <h1>Make Your Website Responsive</h1>
                    <p>
                      Go beyond the traditional boundaries of the web and explore the future of modern responsive website designing by making them beautiful across multiple devices and perfectly fit at any browser operated device
                    </p>
                  </div>
                  <div className="slide-img">
                    <img src="assets/images/slide.png" alt="Banner1" className="img-responsive" />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="item">
                  <div className="slide-text">
                    <h1>Make Your Website Responsive</h1>
                    <p>
                      Go beyond the traditional boundaries of the web and explore the future of modern responsive website designing by making them beautiful across multiple devices and perfectly fit at any browser operated device
                    </p>
                  </div>
                  <div className="slide-img">
                    <img src="assets/images/slide.png" alt="Banner2" className="img-responsive" />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
      <div className="bottom-shadow">&nbsp;</div>
    </section>
  );
}

export default Banner;